import React from "react";
import { FiUsers } from "react-icons/fi";

const Community: React.FC = () => {
  return (
    <div
      style={{
        padding: "24px",
        backgroundColor: "#fafbfc",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      }}
    >
      <div style={{ textAlign: "center", padding: "40px", maxWidth: "500px" }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
          <div style={{ width: "80px", height: "80px", borderRadius: "50%", background: "#e0f2fe", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <FiUsers size={40} color="#0284c7" />
          </div>
        </div>
        <h2 style={{ fontSize: "24px", fontWeight: "bold", color: "#1f2937", marginBottom: "12px" }}>
          Community is Coming Soon
        </h2>
        <p style={{ fontSize: "16px", color: "#6b7280", lineHeight: "1.5" }}>
          We're building a safe space for students to connect, share experiences, and support each other's mental health journey. Stay tuned!
        </p>
      </div>
    </div>
  );
};

export default Community;
